import React, { useCallback } from 'react';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import { Iconfont } from '@umu/umu-design';
interface PageSelectProps {
    displayPageNum: number;
    totalPages: number;
    onPageJump: (page: number) => void;
    isInputting: boolean;
    inputRef: React.RefObject<HTMLInputElement>;
    onInputBlur: React.FocusEventHandler<HTMLInputElement>;
    onInputFocus: React.FocusEventHandler<HTMLInputElement>;
    onInputKeyDown: React.KeyboardEventHandler<HTMLInputElement>;
    onInputPaste: React.ClipboardEventHandler<HTMLInputElement>;
    onPageInputClick: () => void;
    currentPageText: string;
}

export const PageSelect: React.FC<PageSelectProps> = (props) => {
    const {
        displayPageNum,
        totalPages,
        onPageJump,
        isInputting,
        inputRef,
        onInputBlur,
        onInputFocus,
        onInputKeyDown,
        onInputPaste,
        onPageInputClick,
        currentPageText,
    } = props;
    const handlePageClick = useCallback(
        (e: React.MouseEvent<HTMLSpanElement>, page: number) => {
            e.preventDefault();
            e.stopPropagation();
            onPageJump(page);
        },
        [onPageJump],
    );
    return (
        <div className="toolbar-page-content umu-pdf-mobile-hide">
            <Iconfont
                type="Bigback"
                className={classNames('toolbar-icon-page', {
                    'toolbar-icon-page-disabled': !isNumber(displayPageNum) || displayPageNum <= 1,
                })}
                onClick={(e) => handlePageClick(e, displayPageNum - 1)}
            />
            <div className="toolbar-num-box">
                {isInputting ? (
                    <input
                        ref={inputRef}
                        className="toolbar-input"
                        onBlur={onInputBlur}
                        onFocus={onInputFocus}
                        type="number"
                        step={1}
                        inputMode="numeric"
                        autoFocus
                        onKeyDown={onInputKeyDown}
                        onPaste={onInputPaste}
                        onMouseDown={(e) => e.stopPropagation()}
                        onSelect={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            MozUserSelect: 'text',
                            msUserSelect: 'text',
                        }}
                    />
                ) : (
                    <span
                        className="toolbar-page-display"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onPageInputClick();
                        }}
                    >
                        {currentPageText}
                    </span>
                )}
            </div>
            <Iconfont
                type="BigMore"
                className={classNames('toolbar-icon-page', {
                    'toolbar-icon-page-disabled': !isNumber(displayPageNum) || displayPageNum >= totalPages,
                })}
                onClick={(e) => handlePageClick(e, displayPageNum + 1)}
            />
        </div>
    );
};
